// extracted by mini-css-extract-plugin
module.exports = {"navbarFooter":"style_navbarFooter__2SpJz","navbarCentered":"style_navbarCentered__rc-QL"};